import { selectors as UsersSelectors } from 'data/users'
import { selectors as ChannelsSelectors } from 'data/channels'
import {
  canManageNote,
  canEditNote,
  canCreateNote,
  canManageChannel,
} from 'remote/channels/roles'

export function currentUserCanCreateNote(state, channel) {
  if (!channel) {
    return false
  }
  const user = UsersSelectors.getCurrentUser(state)
  return canCreateNote({ channel, user })
}

export function currentUserCanManageNote(state, note) {
  if (!note) {
    return false
  }
  const user = UsersSelectors.getCurrentUser(state)
  const channel = ChannelsSelectors.getChannel(state, note.getChannelId())
  if (!channel) {
    return false
  }
  return canManageNote({ user, note, channel })
}

export function currentUserCanEditNote(state, note) {
  if (!note) {
    return false
  }
  const user = UsersSelectors.getCurrentUser(state)
  const channel = ChannelsSelectors.getChannel(state, note.getChannelId())
  if (!channel) {
    return false
  }
  return canEditNote({ user, note, channel })
}

export function currentUserCanDeleteNote(state, note) {
  // This has to be sync with api/src/note-permissions.js
  if (!note) {
    return false
  }
  const user = UsersSelectors.getCurrentUser(state)
  const channel = ChannelsSelectors.getChannel(state, note.getChannelId())
  if (!channel) {
    return false
  }

  const userIsTheNoteCreator = note.createdBy === user.id
  const isInUserPersonalChannel = channel.createdBy === user.id
  const userIsChannelAdmin = canManageChannel({ channel, user })
  const userIsTeamAdminOrOwner = UsersSelectors.canCurrentUserManageOrganization(
    state
  )

  return (
    userIsTheNoteCreator ||
    isInUserPersonalChannel ||
    userIsChannelAdmin ||
    userIsTeamAdminOrOwner
  )
}

export function currentUserCanManageChannel(state, channel) {
  const user = UsersSelectors.getCurrentUser(state)
  return canManageChannel({ channel, user })
}
